import React from 'react';
import { FormattedMessage } from 'react-intl';
import { css } from 'aphrodite/no-important';
import { Heading } from '@trainline/depot-web';
import { Payment } from 'packages/hooks/api/useFetchJourneys';

import messages from './messages';
import TransactionsList from './TransactionsList/TransactionsList';
import PaymentDetail from './PaymentDetail/PaymentDetail';
import styles from './styles';

interface Props {
  payment: Payment;
  isCurrent: boolean;
  lastDayOfSelectedPeriod?: string;
}

export const PaymentSummary = ({ payment, isCurrent, lastDayOfSelectedPeriod }: Props) => (
  <>
    <Heading className={css(styles.title)}>
      <FormattedMessage {...messages.paymentSummary} />
    </Heading>
    <div className={css(styles.container)}>
      <TransactionsList
        payment={payment}
        isCurrent={isCurrent}
        lastDayOfSelectedPeriod={lastDayOfSelectedPeriod}
      />
      <PaymentDetail payment={payment} isCurrent={isCurrent} />
    </div>
  </>
);
